module.exports = "/_next/static/images/Supercharge@2x-c34fa2f4235dc88322d4ec7961c9117b.png";